import { render, staticRenderFns } from "./BaseEmpty.vue?vue&type=template&id=3fee1c72&scoped=true&"
import script from "./BaseEmpty.vue?vue&type=script&lang=js&"
export * from "./BaseEmpty.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmpty.vue?vue&type=style&index=0&id=3fee1c72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee1c72",
  null
  
)

export default component.exports